import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { compose, withHandlers } from "recompose";
import { isEmpty, map, filter } from "lodash";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import CardTitle from "react-md/lib/Cards/CardTitle";
import Button from "react-md/lib/Buttons/Button";

import TextField from "../../form/TextField";
import List from "./List";

import { setActiveForm } from "../../../actions/appActions";
import {
  updateOrganizationNormal,
  getOrganizationNormal
} from "../../../actions/resourceActions";

import {DebugElement} from "../../../Atollon/debug";


const RequestTypes = ({
  handleSubmit,
  activeForm,
  setActiveForm,
  items,
  updateOrganizationNormal,
  getOrganizationNormal,
  organization
}) => (
  <Card className="card">
      <DebugElement text={"src/components/settings/organizationEdit/RequestTypes.js"}/>
    <CardTitle title="VLASTNÍ TYPY POŽADAVKŮ" />
    {items && !isEmpty(items) ? (
      <CardText className="padding-none">
        <List
          items={map(items, item => {
            return {
              primary: item.value,
              onClick: () => {
                updateOrganizationNormal({
                  ...organization,
                  requestCustomTypes: filter(
                    organization.requestCustomTypes,
                    type => type.value !== item.value
                  )
                });
                getOrganizationNormal(organization.identifier);
              }
            };
          })}
        />
      </CardText>
    ) : (
      <div />
    )}
    <CardText>
      {activeForm === "organizationRequestTypes" ? (
        <form onSubmit={handleSubmit}>
          <div className="flex-col">
            <Field component={TextField} label="Hodnota" name="value" />
          </div>
          <div className="flex-row flex-right">
            <Button
              raised
              className="btn"
              label="Cancel"
              onClick={() => setActiveForm(null)}
            />
            <Button
              raised
              className="btn btn-primary"
              label="Přidat"
              type="submit"
            />
          </div>
        </form>
      ) : (
        <Button
          raised
          className="btn btn-primary"
          label="Přidat nový vlastní typ"
          onClick={() => setActiveForm("organizationRequestTypes")}
        />
      )}
    </CardText>
  </Card>
);

export default compose(
  connect(({ app: { form: { activeForm } } }) => ({ activeForm }), {
    setActiveForm,
    updateOrganizationNormal,
    getOrganizationNormal
  }),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const {
        updateOrganizationNormal,
        organization,
        setActiveForm,
        getOrganizationNormal
      } = props;
      const { value } = formData;

      if (
        await updateOrganizationNormal({
          ...organization,
          requestCustomTypes: [...organization.requestCustomTypes, { value }]
        })
      ) {
        getOrganizationNormal(organization.identifier);
        setActiveForm(null);
      } else {
        throw new SubmissionError({
          value: "Přidání nového typu se nezdařilo."
        });
      }
    }
  }),
  reduxForm({ form: "organizationRequestTypes" })
)(RequestTypes);



// WEBPACK FOOTER //
// ./src/components/settings/organizationEdit/RequestTypes.js